import React, { useEffect, useState, lazy, createElement } from 'react';
import { Check, Clock, Shield, Star, ChevronDown, ChevronUp, Download, Lock, Infinity } from 'lucide-react';
import { PurchaseNotification } from '../components/PurchaseNotification';
export function LandingPage() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 14,
    seconds: 59
  });
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  useEffect(() => {
    // Meta Pixel Code
    const script = document.createElement('script');
    script.innerHTML = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','1170774765082882');fbq('track','PageView');`;
    document.head.appendChild(script);
    // Noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=1170774765082882&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
  }, []);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          ...prev,
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return {
          hours: 0,
          minutes: 14,
          seconds: 59
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const checkoutUrl = 'https://checkout.recursospro.shop/cart/47599804809472:1';
  const scrollToCheckout = () => {
    const checkoutSection = document.getElementById('checkout-section');
    if (checkoutSection) {
      checkoutSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const tomos = [{
    num: 1,
    emoji: '📘',
    title: 'Fundamentos musicales + actividades listas',
    subtitle: 'El punto de partida para enseñar Música sin improvisar.',
    items: ['Sonido, silencio, ritmo y expresión', 'Actividades listas para aplicar', 'Primer contacto con instrumentos', 'Canciones y repertorio', 'Evaluación sin estrés']
  }, {
    num: 2,
    emoji: '📗',
    title: 'Ritmo, percusión y ensamble',
    subtitle: 'Clases dinámicas que se mueven y funcionan.',
    items: ['Percusión corporal e instrumental', 'Ensambles grupales', 'Estrategias para grupos grandes', 'Ritmo sin caos']
  }, {
    num: 3,
    emoji: '📕',
    title: 'Lectura musical simple y sin miedo',
    subtitle: 'Cómo enseñar lectura musical sin frustración.',
    items: ['Método progresivo y visual', 'Figuras, símbolos y pentagrama explicados fácil', 'Actividades imprimibles', 'Evaluación clara']
  }, {
    num: 4,
    emoji: '📙',
    title: 'Creación musical, composición y proyectos',
    subtitle: 'Para que tus alumnos creen música real.',
    items: ['Exploración sonora', 'Improvisación guiada', 'Composición paso a paso', 'Proyectos interdisciplinarios']
  }, {
    num: 5,
    emoji: '📓',
    title: 'Actos escolares y cierre anual',
    subtitle: 'Tu respaldo profesional para todo el año.',
    items: ['Actos escolares sin estrés', 'Proyectos institucionales', 'Muestras musicales', 'Cierre del año con producciones visibles']
  }];
  const bonos = [{
    num: 1,
    title: 'Partituras del Mundo',
    desc: 'Repertorio musical multicultural listo para usar en clase.',
    image: 'https://cdn.magicpatterns.com/uploads/3fa4AwUsYi4ED2M45g3kk7/pasted-image.png',
    items: ['Partituras de distintas regiones del mundo', 'Canciones tradicionales e internacionales', 'Material ideal para actos y efemérides', 'Propuestas para trabajar diversidad cultural']
  }, {
    num: 2,
    title: 'Música Infantil & Bebés',
    desc: 'Kit especial para nivel inicial y maternal.',
    image: 'https://cdn.magicpatterns.com/uploads/qwBr2batedoyZRh3SfQiuv/pasted-image.png',
    items: ['Canciones adaptadas para primera infancia', 'Juegos musicales simples y efectivos', 'Recursos visuales y propuestas sensoriales', 'Actividades listas para aplicar sin adaptación']
  }, {
    num: 3,
    title: 'Música + Arte + Teatro',
    desc: 'Proyectos integrados para trabajar de forma interdisciplinaria.',
    image: 'https://cdn.magicpatterns.com/uploads/sgSgSJM5y8kSoeRM43cH1R/pasted-image.png',
    items: ['Propuestas Música + Arte', 'Actividades Música + Teatro', 'Ideas para muestras anuales', 'Producciones creativas que se lucen']
  }, {
    num: 4,
    title: 'Pack Música Lista PRO',
    desc: 'Tomos complementarios para profundizar y ampliar.',
    image: null,
    items: ['Ritmo avanzado y secuencias especiales', 'Profundización en lectura musical', 'Proyectos creativos ampliados', 'Recursos extra para actos y muestras']
  }];
  return <div className="min-h-screen bg-white text-[#0A0A0A]" style={{
    fontFamily: 'system-ui, -apple-system, sans-serif'
  }} data-id="element-40">
      <PurchaseNotification data-id="element-41" />

      {/* URGENCY BAR */}
      <div className="sticky top-0 z-50 bg-[#0A0A0A] text-white py-2.5 px-4" data-id="element-42">
        <div className="flex items-center justify-center gap-2 text-sm" data-id="element-43">
          <Clock className="w-4 h-4" data-id="element-44" />
          <span data-id="element-45">
            Oferta termina en:{' '}
            <strong data-id="element-46">
              {String(timeLeft.hours).padStart(2, '0')}:
              {String(timeLeft.minutes).padStart(2, '0')}:
              {String(timeLeft.seconds).padStart(2, '0')}
            </strong>
          </span>
        </div>
      </div>

      {/* ===== HERO ===== */}
      <section className="py-6 px-4" data-id="element-47">
        <div className="max-w-3xl mx-auto text-center" data-id="element-48">
          <p className="text-[#2563EB] font-semibold text-sm mb-3 tracking-wide" data-id="element-49">
            🎶 PARA DOCENTES DE MÚSICA
          </p>
          <h1 className="text-3xl md:text-5xl font-black leading-[1.1] mb-4 tracking-tight" data-id="element-50">
            ORGANIZÁ TODO
            <br data-id="element-51" />
            TU AÑO DE MÚSICA
            <br data-id="element-52" />
            <span className="text-[#2563EB]" data-id="element-53">SIN ESTRÉS</span>
          </h1>
          <img src="https://cdn.magicpatterns.com/uploads/r2VWX7rZhbWhzTJKvipMTt/pasted-image.png" alt="MegaPack Música Lista" className="mx-auto w-full max-w-[240px] mb-5" loading="eager" data-id="element-54" />
          <div className="mb-6" data-id="element-55">
            <p className="text-[#2563EB] font-bold text-lg mb-2" data-id="element-56">
              🎼 MEGAPACK MÚSICA LISTA™
            </p>
            <p className="text-[#64748B] text-lg leading-relaxed max-w-xl mx-auto" data-id="element-57">
              Sistema completo de clases, actividades y proyectos musicales
              listos para usar.
              <br data-id="element-58" />
              <span className="text-[#0A0A0A] font-medium" data-id="element-59">
                Todo tu año de Música resuelto (Inicial · Primaria · Secundaria)
              </span>
            </p>
          </div>
          <button onClick={scrollToCheckout} className="inline-block bg-[#2563EB] text-white font-bold text-lg py-4 px-10 rounded-lg mb-6 cursor-pointer" data-id="element-60">
            👉 QUIERO ACCESO INMEDIATO
          </button>
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm text-[#64748B]" data-id="element-61">
            <span className="flex items-center gap-1.5" data-id="element-62">
              <Lock className="w-4 h-4 text-[#2563EB]" data-id="element-63" /> Pago 100% seguro
            </span>
            <span className="flex items-center gap-1.5" data-id="element-64">
              <Download className="w-4 h-4 text-[#2563EB]" data-id="element-65" /> Descarga inmediata
            </span>
            <span className="flex items-center gap-1.5" data-id="element-66">
              <Shield className="w-4 h-4 text-[#2563EB]" data-id="element-67" /> Garantía 7 días
            </span>
            <span className="flex items-center gap-1.5" data-id="element-68">
              <Infinity className="w-4 h-4 text-[#2563EB]" data-id="element-69" /> Acceso de por vida
            </span>
          </div>
        </div>
      </section>

      {/* ===== PROBLEMA ===== */}
      <section className="py-12 px-4 bg-[#F8FAFC]" data-id="element-70">
        <div className="max-w-2xl mx-auto" data-id="element-71">
          <h2 className="text-2xl md:text-3xl font-black text-center mb-8" data-id="element-72">
            Si enseñás Música, esto te va a sonar muy familiar…
          </h2>
          <div className="bg-white rounded-xl p-6 border border-[#E2E8F0] mb-8" data-id="element-73">
            <p className="text-[#0A0A0A] text-lg mb-4" data-id="element-74">
              Llegás cansado/a. Sabés que tenés que planificar. Abrís la
              computadora.
            </p>
            <p className="text-[#2563EB] font-bold text-xl mb-6" data-id="element-75">
              Y una vez más empezás desde cero.
            </p>
            <div className="border-t border-[#E2E8F0] pt-6" data-id="element-76">
              <p className="text-[#64748B] font-medium mb-4" data-id="element-77">
                El ciclo del agotamiento:
              </p>
              <div className="grid grid-cols-2 gap-2 text-sm text-[#64748B]" data-id="element-78">
                {['Buscando actividades', 'Buscando canciones', 'Buscando partituras', 'Buscando ideas que funcionen', 'Buscando cómo explicar sin complicar'].map((item, i) => <p key={i} data-id="element-79">• {item}</p>)}
              </div>
              <p className="text-[#0A0A0A] mt-4 italic" data-id="element-80">
                El tiempo pasa rápido. El cansancio aumenta. Y tu cabeza no se
                apaga.
              </p>
            </div>
          </div>
          <div className="bg-[#0A0A0A] text-white rounded-xl p-6 mb-8" data-id="element-81">
            <p className="font-bold mb-4" data-id="element-82">
              El problema real — Todo al mismo tiempo:
            </p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-sm" data-id="element-83">
              {['Planificar clases', 'Pensar actividades', 'Preparar evaluaciones', 'Organizar actos', 'Armar proyectos', 'Motivar estudiantes', 'Registrar avances'].map((item, i) => <span key={i} className="bg-white/10 px-3 py-2 rounded-lg text-center" data-id="element-84">
                  {item}
                </span>)}
            </div>
          </div>
          <div className="text-center" data-id="element-85">
            <p className="text-[#64748B] mb-2" data-id="element-86">
              No es porque no sepas enseñar. No es porque no seas buen/a
              docente.
            </p>
            <p className="text-[#2563EB] font-bold text-xl" data-id="element-87">
              👉 Es porque estás intentando sostener todo el año sin un sistema
              que te sostenga a vos.
            </p>
          </div>
        </div>
      </section>

      {/* ===== SOLUCIÓN ===== */}
      <section className="py-12 px-4" data-id="element-88">
        <div className="max-w-2xl mx-auto text-center" data-id="element-89">
          <p className="text-[#64748B] font-medium mb-2" data-id="element-90">
            La solución definitiva
          </p>
          <h2 className="text-3xl md:text-4xl font-black mb-4" data-id="element-91">
            🎶 MEGAPACK MÚSICA LISTA™
          </h2>
          <p className="text-[#64748B] text-lg mb-8 max-w-xl mx-auto" data-id="element-92">
            Un sistema anual completo de Música, basado en actividades reales,
            probadas en aula y pensadas para la escuela real.
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8" data-id="element-93">
            {[{
            text: 'Todo listo',
            icon: '✓'
          }, {
            text: 'Todo probado',
            icon: '✓'
          }, {
            text: 'Todo organizado',
            icon: '✓'
          }, {
            text: 'Todo usable',
            icon: '✓'
          }].map((item, i) => <div key={i} className="bg-[#DBEAFE] text-[#1E40AF] rounded-xl p-4 font-bold" data-id="element-94">
                <span className="text-2xl block mb-1" data-id="element-95">{item.icon}</span>
                {item.text}
              </div>)}
          </div>
        </div>
      </section>

      {/* ===== 5 TOMOS ===== */}
      <section className="py-12 px-4 bg-[#F8FAFC]" data-id="element-96">
        <div className="max-w-2xl mx-auto" data-id="element-97">
          <h2 className="text-2xl md:text-3xl font-black text-center mb-8" data-id="element-98">
            ¿Qué incluye el MegaPack Música Lista?
          </h2>
          <div className="space-y-4" data-id="element-99">
            {tomos.map(tomo => <div key={tomo.num} className="bg-white rounded-xl p-5 border border-[#E2E8F0]" data-id="element-100">
                <div className="flex items-start gap-4" data-id="element-101">
                  <div className="w-12 h-12 bg-[#2563EB] text-white rounded-lg flex items-center justify-center font-black text-lg shrink-0" data-id="element-102">
                    {tomo.num}
                  </div>
                  <div className="flex-1" data-id="element-103">
                    <h3 className="font-black text-[#0A0A0A] mb-1" data-id="element-104">
                      {tomo.emoji} TOMO {tomo.num} – {tomo.title}
                    </h3>
                    <p className="text-sm text-[#64748B] mb-3" data-id="element-105">
                      {tomo.subtitle}
                    </p>
                    <ul className="space-y-1" data-id="element-106">
                      {tomo.items.map((item, i) => <li key={i} className="flex items-center gap-2 text-sm text-[#0A0A0A]" data-id="element-107">
                          <Check className="w-4 h-4 text-[#2563EB] shrink-0" data-id="element-108" />
                          {item}
                        </li>)}
                    </ul>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* ===== VISTA PREVIA DEL MATERIAL - CARRUSEL ===== */}
      <section className="py-12 px-4" data-id="element-109">
        <div className="max-w-4xl mx-auto" data-id="element-110">
          <div className="text-center mb-8" data-id="element-111">
            <p className="text-[#2563EB] font-bold text-sm mb-2" data-id="element-112">
              👀 MIRÁ POR DENTRO
            </p>
            <h2 className="text-2xl md:text-3xl font-black mb-2" data-id="element-113">
              Así es el material que vas a recibir
            </h2>
            <p className="text-[#64748B]" data-id="element-114">
              Páginas reales del MegaPack. Diseñado para que lo uses sin adaptar
              nada.
            </p>
          </div>

          {/* Carrusel horizontal con scroll */}
          <div className="relative" data-id="element-115">
            <div className="flex gap-4 overflow-x-auto pb-4 snap-x snap-mandatory scrollbar-hide" style={{
            scrollbarWidth: 'none',
            msOverflowStyle: 'none'
          }} data-id="element-116">
              {[{
              src: 'https://cdn.magicpatterns.com/uploads/vG9Hnx6MWYhMsd8nA8hdG7/Captura_de_pantalla_2026-02-02_a_la(s)_4.40.52_p._m..png',
              alt: 'Estructura del tomo'
            }, {
              src: 'https://cdn.magicpatterns.com/uploads/mmqN1nmwUJzArgsXKb6f3k/Captura_de_pantalla_2026-02-02_a_la(s)_4.41.03_p._m..png',
              alt: 'Actividad - El juego del estatua sonora'
            }, {
              src: 'https://cdn.magicpatterns.com/uploads/dRyGns1eSvtSS9v3d33kYb/Captura_de_pantalla_2026-02-02_a_la(s)_4.41.21_p._m..png',
              alt: 'Estructura del Tomo 2'
            }, {
              src: 'https://cdn.magicpatterns.com/uploads/8tEbCLEkbh9oZDDddyF5hh/Captura_de_pantalla_2026-02-02_a_la(s)_4.41.36_p._m..png',
              alt: 'Cómo trabajar ritmo sin partituras'
            }, {
              src: 'https://cdn.magicpatterns.com/uploads/w1uXxF9f87js5Ucx3NggCU/Captura_de_pantalla_2026-02-02_a_la(s)_4.41.56_p._m..png',
              alt: 'Actividades con la negra'
            }, {
              src: 'https://cdn.magicpatterns.com/uploads/3uWw6ChyXkNkmbECrQ6RWJ/Captura_de_pantalla_2026-02-02_a_la(s)_4.42.04_p._m..png',
              alt: 'La Blanca - extendiendo el sonido'
            }, {
              src: 'https://cdn.magicpatterns.com/uploads/hhtZz79ByMDCAqQY6uK8Te/Captura_de_pantalla_2026-02-02_a_la(s)_4.42.21_p._m..png',
              alt: 'Qué es crear música en el aula'
            }, {
              src: 'https://cdn.magicpatterns.com/uploads/v16e1xLBPPXU2Egbo9zrJM/Captura_de_pantalla_2026-02-02_a_la(s)_4.42.31_p._m..png',
              alt: 'Actividad práctica - Mapa sonoro del cuerpo'
            }, {
              src: 'https://cdn.magicpatterns.com/uploads/7uGwo5ABXz4tG4zRLfaak5/Captura_de_pantalla_2026-02-02_a_la(s)_4.42.52_p._m..png',
              alt: 'Actos simples de aula o sala'
            }].map((img, i) => <div key={i} className="flex-shrink-0 w-72 md:w-80 snap-center" data-id="element-117">
                  <div className="bg-white rounded-xl overflow-hidden border border-[#E2E8F0] shadow-sm" data-id="element-118">
                    <img src={img.src} alt={img.alt} className="w-full h-auto" loading="lazy" data-id="element-119" />
                  </div>
                </div>)}
            </div>

            {/* Indicador de scroll */}
            <div className="flex justify-center mt-4 gap-2" data-id="element-120">
              <p className="text-sm text-[#64748B] flex items-center gap-2" data-id="element-121">
                <span data-id="element-122">←</span> Deslizá para ver más <span data-id="element-123">→</span>
              </p>
            </div>
          </div>

          <div className="text-center mt-8" data-id="element-124">
            <p className="text-[#64748B] text-sm mb-4" data-id="element-125">
              Material profesional, organizado y listo para usar desde el primer
              día.
            </p>
            <button onClick={scrollToCheckout} className="inline-block bg-[#2563EB] text-white font-bold text-lg py-4 px-10 rounded-lg cursor-pointer" data-id="element-126">
              👉 QUIERO ESTE MATERIAL
            </button>
          </div>
        </div>
      </section>

      {/* ===== RESULTADOS ===== */}
      <section className="py-12 px-4" data-id="element-127">
        <div className="max-w-2xl mx-auto" data-id="element-128">
          <h2 className="text-2xl md:text-3xl font-black text-center mb-8" data-id="element-129">
            Resultados que transforman
          </h2>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-130">
            <div className="bg-[#F8FAFC] rounded-xl p-6 border border-[#E2E8F0]" data-id="element-131">
              <h3 className="font-bold text-[#0A0A0A] mb-4" data-id="element-132">
                Qué logran tus estudiantes
              </h3>
              <ul className="space-y-3" data-id="element-133">
                {['Comprender la música desde la práctica', 'Participar más en clase', 'Crear producciones reales', 'Disfrutar las actividades', 'Valorar la música en su vida cotidiana'].map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-[#0A0A0A]" data-id="element-134">
                    <Check className="w-4 h-4 text-[#2563EB] shrink-0 mt-0.5" data-id="element-135" />
                    {item}
                  </li>)}
              </ul>
            </div>
            <div className="bg-[#DBEAFE] rounded-xl p-6 border border-[#93C5FD]" data-id="element-136">
              <h3 className="font-bold text-[#1E40AF] mb-4" data-id="element-137">
                Qué obtenés vos como docente
              </h3>
              <ul className="space-y-3" data-id="element-138">
                {['Ahorrar horas de planificación cada semana', 'Dejar de improvisar', 'Tener todo el año organizado', 'Enseñar con claridad y seguridad', 'Llegar al cierre del ciclo sin estrés', 'Destacarte con propuestas musicales sólidas'].map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-[#1E40AF]" data-id="element-139">
                    <Check className="w-4 h-4 shrink-0 mt-0.5" data-id="element-140" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
          <div className="text-center mt-8" data-id="element-141">
            <button onClick={scrollToCheckout} className="inline-block bg-[#2563EB] text-white font-bold text-lg py-4 px-10 rounded-lg cursor-pointer" data-id="element-142">
              👉 QUIERO LOGRAR ESTO
            </button>
            <div className="flex justify-center gap-4 mt-4 text-xs text-[#64748B]" data-id="element-143">
              <span data-id="element-144">Pago 100% seguro</span>
              <span data-id="element-145">Descarga inmediata</span>
              <span data-id="element-146">Acceso de por vida</span>
            </div>
          </div>
        </div>
      </section>

      {/* ===== BONOS CON IMÁGENES ===== */}
      <section className="py-12 px-4 bg-[#F8FAFC]" data-id="element-147">
        <div className="max-w-2xl mx-auto" data-id="element-148">
          <div className="text-center mb-8" data-id="element-149">
            <p className="text-[#2563EB] font-bold text-sm mb-2" data-id="element-150">
              🎁 OFERTA ESPECIAL
            </p>
            <h2 className="text-2xl md:text-3xl font-black mb-2" data-id="element-151">
              BONOS INCLUIDOS HOY — GRATIS
            </h2>
            <p className="text-[#64748B]" data-id="element-152">
              Al adquirir tu MegaPack, además de los 5 tomos base, recibís
              GRATIS estos 4 bonos exclusivos.
            </p>
          </div>
          <div className="space-y-6" data-id="element-153">
            {bonos.map(bono => <div key={bono.num} className="bg-white rounded-xl overflow-hidden border-2 border-[#2563EB]" data-id="element-154">
                <div className="flex flex-col md:flex-row" data-id="element-155">
                  {bono.image && <div className="md:w-56 shrink-0 bg-[#F8FAFC] flex items-center justify-center p-4" data-id="element-156">
                      <img src={bono.image} alt={bono.title} className="w-44 h-44 object-contain" loading="lazy" data-id="element-157" />
                    </div>}
                  <div className="flex-1 p-5" data-id="element-158">
                    <div className="flex items-center justify-between mb-2 flex-wrap gap-2" data-id="element-159">
                      <h3 className="font-black text-[#0A0A0A]" data-id="element-160">
                        BONO {bono.num} – {bono.title}
                      </h3>
                      <span className="bg-[#2563EB] text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-161">
                        ✨ GRATIS HOY
                      </span>
                    </div>
                    <p className="text-sm text-[#64748B] mb-3" data-id="element-162">{bono.desc}</p>
                    <ul className="grid grid-cols-1 sm:grid-cols-2 gap-1" data-id="element-163">
                      {bono.items.map((item, i) => <li key={i} className="flex items-center gap-2 text-xs text-[#0A0A0A]" data-id="element-164">
                          <Check className="w-3 h-3 text-[#2563EB] shrink-0" data-id="element-165" />
                          {item}
                        </li>)}
                    </ul>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* ===== OFERTA / CHECKOUT MEJORADO ===== */}
      <section id="checkout-section" className="py-12 px-4" data-id="element-166">
        <div className="max-w-md mx-auto" data-id="element-167">
          <div className="bg-white rounded-2xl p-8 text-center border-2 border-[#2563EB] shadow-xl" data-id="element-168">
            <p className="text-[#2563EB] font-bold text-sm mb-2" data-id="element-169">
              🔥 Oferta especial por tiempo limitado
            </p>
            <h2 className="text-2xl font-black text-[#0A0A0A] mb-1" data-id="element-170">
              MEGAPACK MÚSICA LISTA
            </h2>
            <p className="text-[#64748B] text-sm mb-6" data-id="element-171">
              5 Tomos Base + 4 Bonos PRO
            </p>

            <p className="text-[#DC2626] line-through text-lg font-medium" data-id="element-172">
              Precio regular $66.990 ARS
            </p>
            <p className="text-5xl font-black text-[#0A0A0A] mb-1" data-id="element-173">$19.990</p>
            <p className="text-[#64748B] text-sm mb-6" data-id="element-174">ARS · Pago único</p>

            <div className="grid grid-cols-2 gap-2 text-sm text-[#0A0A0A] mb-6" data-id="element-175">
              <span className="flex items-center justify-center gap-2 bg-[#F0FDF4] py-2 rounded-lg" data-id="element-176">
                <Check className="w-4 h-4 text-[#22C55E]" data-id="element-177" /> Pago único
              </span>
              <span className="flex items-center justify-center gap-2 bg-[#F0FDF4] py-2 rounded-lg" data-id="element-178">
                <Check className="w-4 h-4 text-[#22C55E]" data-id="element-179" /> Acceso de por vida
              </span>
              <span className="flex items-center justify-center gap-2 bg-[#F0FDF4] py-2 rounded-lg" data-id="element-180">
                <Check className="w-4 h-4 text-[#22C55E]" data-id="element-181" /> Descarga inmediata
              </span>
              <span className="flex items-center justify-center gap-2 bg-[#F0FDF4] py-2 rounded-lg" data-id="element-182">
                <Check className="w-4 h-4 text-[#22C55E]" data-id="element-183" /> Garantía 7 días
              </span>
              <span className="col-span-2 flex items-center justify-center gap-2 bg-[#DBEAFE] py-2 rounded-lg text-[#1E40AF] font-medium" data-id="element-184">
                <Check className="w-4 h-4" data-id="element-185" /> 4 Bonos incluidos
              </span>
            </div>

            <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="block w-full bg-[#2563EB] hover:bg-[#1D4ED8] text-white font-bold text-xl py-5 rounded-xl transition-colors shadow-lg" data-id="element-186">
              👉 SÍ, QUIERO EL MEGAPACK MÚSICA
            </a>

            <div className="mt-6 pt-4 border-t border-[#E2E8F0]" data-id="element-187">
              <p className="text-xs text-[#64748B] mb-2" data-id="element-188">Pago seguro con</p>
              <img src="https://http2.mlstatic.com/frontend-assets/ml-web-navigation/ui-navigation/6.6.92/mercadolibre/logo_large_25years@2x.png" alt="Mercado Pago" className="h-8 mx-auto" loading="lazy" data-id="element-189" />
            </div>
          </div>
        </div>
      </section>

      {/* ===== GARANTÍA ===== */}
      <section className="py-12 px-4 bg-[#F8FAFC]" data-id="element-190">
        <div className="max-w-md mx-auto text-center" data-id="element-191">
          <div className="bg-white rounded-xl p-8 border border-[#E2E8F0]" data-id="element-192">
            <Shield className="w-16 h-16 text-[#2563EB] mx-auto mb-4" data-id="element-193" />
            <h3 className="text-xl font-black text-[#0A0A0A] mb-3" data-id="element-194">
              Garantía de satisfacción total
            </h3>
            <p className="text-[#64748B]" data-id="element-195">
              Probalo durante 7 días. Si no cumple tus expectativas, te
              devolvemos el 100% de tu dinero.
              <br data-id="element-196" />
              <strong className="text-[#0A0A0A]" data-id="element-197">
                Sin preguntas. Sin complicaciones.
              </strong>
            </p>
          </div>
        </div>
      </section>

      {/* ===== TESTIMONIOS ===== */}
      <section className="py-12 px-4" data-id="element-198">
        <div className="max-w-xl mx-auto" data-id="element-199">
          <h2 className="text-xl font-black text-center mb-6" data-id="element-200">
            Lo que dicen otros docentes
          </h2>
          <div className="space-y-3" data-id="element-201">
            {[{
            quote: 'Ahora tengo todo el año organizado.',
            stars: 5
          }, {
            quote: 'Dejé de improvisar las clases.',
            stars: 5
          }, {
            quote: 'Es el único material que uso.',
            stars: 5
          }].map((t, i) => <div key={i} className="bg-[#F8FAFC] p-4 rounded-xl border border-[#E2E8F0]" data-id="element-202">
                <div className="flex items-center gap-1 mb-2" data-id="element-203">
                  {[...Array(t.stars)].map((_, j) => <Star key={j} className="w-4 h-4 text-[#FBBF24] fill-[#FBBF24]" data-id="element-204" />)}
                </div>
                <p className="text-[#0A0A0A] italic" data-id="element-205">"{t.quote}"</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* ===== FAQ ===== */}
      <section className="py-12 px-4 bg-[#F8FAFC]" data-id="element-206">
        <div className="max-w-xl mx-auto" data-id="element-207">
          <h2 className="text-xl font-black text-center mb-6" data-id="element-208">
            Preguntas frecuentes
          </h2>
          <div className="space-y-2" data-id="element-209">
            {[{
            q: '¿En qué formato recibo el material?',
            a: '100% digital (PDF descargables).'
          }, {
            q: '¿Puedo imprimirlo?',
            a: 'Sí, está diseñado para imprimir o proyectar.'
          }, {
            q: '¿Qué niveles abarca?',
            a: 'Inicial, Primaria y Secundaria.'
          }, {
            q: '¿Cuándo recibo el acceso?',
            a: 'Inmediatamente después del pago.'
          }].map((faq, i) => <div key={i} className="border border-[#E2E8F0] rounded-lg overflow-hidden bg-white" data-id="element-210">
                <button onClick={() => setOpenFaq(openFaq === i ? null : i)} className="w-full px-4 py-3 text-left flex items-center justify-between font-medium text-[#0A0A0A]" data-id="element-211">
                  {faq.q}
                  {openFaq === i ? <ChevronUp className="w-4 h-4 text-[#64748B]" data-id="element-212" /> : <ChevronDown className="w-4 h-4 text-[#64748B]" data-id="element-213" />}
                </button>
                {openFaq === i && <div className="px-4 py-3 bg-[#F8FAFC] border-t border-[#E2E8F0]" data-id="element-214">
                    <p className="text-sm text-[#64748B]" data-id="element-215">{faq.a}</p>
                  </div>}
              </div>)}
          </div>
        </div>
      </section>

      {/* ===== CTA FINAL ===== */}
      <section className="py-16 px-4 bg-[#2563EB] text-white" data-id="element-216">
        <div className="max-w-md mx-auto text-center" data-id="element-217">
          <h2 className="text-2xl font-black mb-2" data-id="element-218">
            ¿Listo para transformar tu año escolar?
          </h2>
          <p className="text-blue-100 mb-6" data-id="element-219">
            Unite a miles de docentes que ya organizan su año de Música sin
            estrés.
          </p>
          <button onClick={scrollToCheckout} className="block w-full bg-white text-[#2563EB] font-bold text-lg py-4 rounded-lg mb-4 cursor-pointer" data-id="element-220">
            👉 QUIERO EMPEZAR AHORA
          </button>
          <p className="text-xs text-blue-200" data-id="element-221">
            Descarga inmediata · Garantía 7 días
          </p>
        </div>
      </section>

      <div className="h-20 md:hidden" data-id="element-222" />
    </div>;
}